// components/OrderComplete.js
import React from "react";

const OrderComplete = ({ order }) => {
    return (
        <div className="max-w-3xl mx-auto p-6 bg-white shadow-md space-y-6 my-16">
            <h1 className="text-2xl font-bold text-center">
                Vielen Dank für Ihre Bestellung!
            </h1>

            <div className="space-y-4">
                <p className="text-lg font-semibold">
                    Ihre Bestellnummer lautet:{" "}
                    <span className="text-blue-600">{order.orderNumber}</span>
                </p>
                <p className="text-sm text-gray-600">
                    {order.pickup ? "Abholung" : "Lieferung"}
                </p>
                {!order.pickup && (
                    <p className="text-sm text-gray-600">
                        Lieferadresse: {order.formData.street},{" "}
                        {order.formData.zipCode} {order.formData.city}
                    </p>
                )}

                <div className="cart-summary space-y-4">
                    <h2 className="text-xl font-bold">Bestellte Artikel:</h2>
                    {order.cart &&
                        Object.values(order.cart).map((item) => (
                            <div
                                key={item.id}
                                className="flex justify-between items-start bg-gray-100 p-4 rounded-lg flex-wrap space-y-2"
                            >
                                <div>
                                    <p className="text-lg font-semibold">
                                        {item.title}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                        {item.description}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                        {item.beilage !== ""
                                            ? "mit " + item.beilage
                                            : ""}
                                    </p>
                                    <div className="flex flex-row space-x-2">
                                        <p className="text-sm font-semibold">
                                            Menge: {item.quantity}
                                        </p>
                                        <p className="text-sm font-semibold">
                                            Einzelpreis: {item.price.toFixed(2)}
                                            €
                                        </p>
                                    </div>
                                </div>
                                <p className="text-sm text-black">
                                    {item.customerComment}
                                </p>
                                <p className="text-sm font-semibold">
                                    Gesamt:{" "}
                                    {(item.price * item.quantity).toFixed(2)}€
                                </p>
                            </div>
                        ))}
                </div>
                <h2 className="text-xl font-bold text-right">
                    Gesamtpreis: {order.totalPrice.toFixed(2)}€
                </h2>
            </div>

            <div className="text-center">
                <p className="text-sm text-gray-600">
                    Wir danken Ihnen für Ihr Vertrauen!
                </p>
                <p className="text-sm text-gray-600">
                    Falls Sie Fragen haben, kontaktieren Sie uns unter{" "}
                    <span className="text-blue-600">info@enedem.de</span>.
                </p>
            </div>
        </div>
    );
};

export default OrderComplete;
